import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output} from "@angular/core";
import {PageContentMode} from "../../abstract-edit-page";

@Component({
    selector: "wbo-edit-page-content-mode-toggle-control",
    templateUrl: "./edit-page-content-mode-toggle-control.component.html",
    styleUrls: ["./edit-page-content-mode-toggle-control.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditPageContentModeToggleControlComponent {
    PageContentMode = PageContentMode;

    @Input() @HostBinding("class.disabled") disabled: boolean;
    @Input() basicLabel: string = "wbo.common.button.basic";
    @Input() customLabel1: string;
    @Input() customLabel2: string;
    @Input() customLabel3: string;
    @Input() detailedLabel: string = "wbo.common.button.detailed";

    @Output() modeChanged: EventEmitter<PageContentMode> = new EventEmitter<PageContentMode>();

    private _mode: PageContentMode = PageContentMode.BASIC;

    get mode(): PageContentMode {
        return this._mode;
    }

    @Input() set mode(mode: PageContentMode) {
        if (mode !== this._mode) {
            this._mode = mode;
            this.modeChanged.emit(mode);
        }
    }
}
